import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ca from "./assets/i18n/lang/ca/global.json";
import es from "./assets/i18n/lang/es/global.json";
import en from "./assets/i18n/lang/en/global.json";

i18next
// if you want your translations to be loaded from a professional CDN
//  .use(Backend)

  // to detect user language
  .use(LanguageDetector)

  // to pass the i18n instance to react-i18next.
  .use(initReactI18next)


  // init i18next
.init({
	
    fallbackLng: 'es',
    
    debug: true,
    
    resources: {
	    ca: {
			global: ca
		},
	    es: {
			global: es
		},
	    en: {
			global: en
		}
	},
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  	<I18nextProvider i18n={i18next}>
    	<App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
